<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header" style="padding: 0">
        <el-collapse v-model="activeCollapse" @change="handleCollapse">
          <el-collapse-item name="1">
            <template slot="title">{{ titleFilter }}</template>

            <div class="row m-1 mb-1">
              <div class="col-md-4">
                <label>{{ $t('consolidatedSummary.zone') }}:</label>
                <br />
                <el-select
                  clearable
                  filterable
                  multiple
                  collapse-tags
                  class="select-primary w-100 mb-3 shadow-sm"
                  :placeholder="`${$t('common_words.select2')}...`"
                  v-model="payload.zones"
                  @change="
                    selectAllFromSelect('payload.zones', zones);
                    onZoneChange();
                  "
                >
                  <el-option
                    v-for="zone in zones"
                    class="select-primary selected-all"
                    :key="zone.id"
                    :label="zone.name"
                    :value="zone.id"
                  />
                </el-select>
              </div>

              <div class="col-md-4">
                <label>{{ $t('devices.station') }}:</label>
                <br />
                <el-select
                  clearable
                  filterable
                  multiple
                  collapse-tags
                  class="select-primary w-100 mb-3 shadow-sm"
                  :placeholder="`${$t('common_words.select2')}...`"
                  v-model="payload.stations"
                  :disabled="!payload.zones || payload.zones.length === 0"
                  @change="
                    selectAllFromSelect('payload.stations', filteredStations);
                    onStationChange();
                  "
                >
                  <el-option
                    v-for="station in filteredStations"
                    class="select-primary selected-all"
                    :key="station.id"
                    :label="station.name"
                    :value="station.id"
                  />
                </el-select>
              </div>

              <div class="col-md-4">
                <label>{{ $t('consolidatedSummary.farm') }}:</label>
                <br />
                <el-select
                  clearable
                  filterable
                  multiple
                  collapse-tags
                  class="select-primary w-100 mb-3 shadow-sm"
                  :placeholder="`${$t('common_words.select2')}...`"
                  v-model="payload.farms"
                  :disabled="!payload.stations || payload.stations.length === 0"
                  @change="
                    selectAllFromSelect('payload.farms', filteredFarms);
                    onFarmChange();
                  "
                >
                  <el-option
                    v-for="farm in filteredFarms"
                    class="select-primary selected-all"
                    :key="farm.id"
                    :label="farm.name"
                    :value="farm.id"
                  />
                </el-select>
              </div>
            </div>

            <div class="row m-1">
              <div class="col-md-auto">
                <label>{{ $t('common_words.analyze_by') }}</label>
                <br />
                <el-select
                  @change="changeByInterval()"
                  filterable
                  class="select-primary custom-width-select mb-3 required-year shadow-sm"
                  size="large"
                  v-model="payload.frecuency"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="option in Object.values(optionsInterval)"
                    class="select-primary"
                    :value="option.id"
                    :label="option.label"
                    :key="option.id"
                  />
                </el-select>
              </div>

              <div
                class="col-md-auto"
                v-if="
                  payload.frecuency !== 'weekly' &&
                  payload.frecuency !== 'annually'
                "
              >
                <label>{{ $t('common_words.calendar') }}</label>
                <br />
                <el-date-picker
                  v-if="renderDatePicker"
                  v-model="payload.rangeDate"
                  class="shadow-sm mb-3"
                  v-bind:type="typedatepicket"
                  range-separator="-"
                  :clearable="false"
                  :picker-options="pickerOptions"
                  :placeholder="`${$t('common_words.select2')}...`"
                  :start-placeholder="$t('common_words.initial_date')"
                  :end-placeholder="$t('common_words.final_date')"
                />
              </div>

              <div
                class="col-md-auto"
                v-if="
                  payload.frecuency === 'weekly' ||
                  payload.frecuency === 'annually'
                "
              >
                <label>{{ $t('common_words.initial_year') }}:</label>
                <br />
                <el-select
                  filterable
                  class="select-primary custom-width-select mb-3 required-year shadow-sm"
                  size="large"
                  v-model="payload.year_sel_init"
                >
                  <el-option
                    v-for="(opt, idx) in Object.keys(listYears).reverse()"
                    class="select-primary"
                    :value="opt"
                    :label="opt"
                    :key="idx"
                  />
                </el-select>
              </div>

              <div class="col-md-auto" v-if="payload.frecuency === 'weekly'">
                <label>{{ $t('common_words.initial_week') }}:</label>
                <br />
                <el-select
                  filterable
                  class="select-primary custom-width-select mb-3 required-week shadow-sm"
                  size="large"
                  v-model="payload.week_sel_init"
                >
                  <el-option
                    v-for="(week, idx) in listYears[payload.year_sel_init]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="idx"
                  />
                </el-select>
              </div>

              <div
                class="col-md-auto"
                v-if="
                  payload.frecuency === 'weekly' ||
                  payload.frecuency === 'annually'
                "
              >
                <label>{{ $t('common_words.end_year') }}:</label>
                <br />
                <el-select
                  filterable
                  class="select-primary custom-width-select mb-3 required-year shadow-sm"
                  size="large"
                  v-model="payload.year_sel_end"
                >
                  <el-option
                    v-for="(opt, idx) in Object.keys(listYears).reverse()"
                    class="select-primary"
                    :value="opt"
                    :label="opt"
                    :key="idx"
                  />
                </el-select>
              </div>

              <div class="col-md-auto" v-if="payload.frecuency === 'weekly'">
                <label>{{ $t('common_words.end_week2') }}:</label>
                <br />
                <el-select
                  filterable
                  class="select-primary custom-width-select mb-3 required-week shadow-sm"
                  size="large"
                  v-model="payload.week_sel_end"
                >
                  <el-option
                    v-for="(week, idx) in listYears[payload.year_sel_end]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="idx"
                  />
                </el-select>
              </div>

              <div class="col text-left col-btn-filter pl-0">
                <label style="color: transparent">{{
                  $t('common_words.filter')
                }}</label>
                <br />
                <l-button
                  class="shadow-sm btn-filter"
                  wide
                  type="success"
                  @click="getReportData()"
                  >{{ $t('common_words.filter') }}</l-button
                >
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </card>
    </div>

    <div class="col-12 mb-4" v-if="showReport">
      <card class="custom-shadow-card-header">
        <!-- Resumen General -->
        <el-table
          :data="[summaryGeneral]"
          border
          stripe
          style="width: 100%"
          class="mb-4"
        >
          <el-table-column
            :label="
              $t('common_words.table') +
              ': ' +
              $t('consolidatedSummary.resumenGeneral')
            "
            align="center"
          >
            <el-table-column align="center">
              <template slot="header">
                {{ $t('consolidatedSummary.tempProm') }}<br /><small
                  >(°C)</small
                >
              </template>
              <template slot-scope="s">
                <span style="text-transform: none">{{
                  formatVal(s.row.temp_avg)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center">
              <template slot="header">
                {{ $t('consolidatedSummary.hrProm') }}<br /><small>(%)</small>
              </template>
              <template slot-scope="s">
                <span style="text-transform: none">{{
                  formatVal(s.row.hr_avg)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center">
              <template slot="header">
                {{ $t('consolidatedSummary.lluviaProm') }}<br /><small
                  >(mm)</small
                >
              </template>
              <template slot-scope="s">
                <span style="text-transform: none">{{
                  formatVal(s.row.rain_avg)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center">
              <template slot="header">
                {{ $t('consolidatedSummary.probProm') }}<br /><small>(%)</small>
              </template>
              <template slot-scope="s">
                <span style="text-transform: none">{{
                  formatVal(s.row.rain_prob_avg)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center">
              <template slot="header">
                {{ $t('consolidatedSummary.vientoProm') }}<br /><small
                  >(km/h)</small
                >
              </template>
              <template slot-scope="s">
                <span style="text-transform: none">{{
                  formatVal(s.row.wind_avg)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center">
              <template slot="header">
                {{ $t('consolidatedSummary.radiacionProm') }}<br /><small
                  >(W/m²)</small
                >
              </template>
              <template slot-scope="s">
                <span style="text-transform: none">{{
                  formatVal(s.row.radiation_avg)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center">
              <template slot="header">
                {{ $t('consolidatedSummary.etoProm') }}<br /><small>(mm)</small>
              </template>
              <template slot-scope="s">
                <span style="text-transform: none">{{
                  formatVal(s.row.eto_avg)
                }}</span>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>

        <hr class="my-3" />

        <!-- Detalle Consolidado -->
        <card-header
          :propPagination="pagination"
          @searchedQuery="searchedQuery"
          class="mr-3 mt-3"
        ></card-header>

        <el-table
          :data="queriedData"
          :span-method="objectSpanMethod"
          border
          stripe
          style="width: 100%"
        >
          <el-table-column
            :label="
              $t('common_words.table') +
              ': ' +
              $t('consolidatedSummary.detalleConsolidado')
            "
            align="center"
          >
            <el-table-column
              :label="$t('consolidatedSummary.zone')"
              min-width="130"
              align="left"
            >
              <template slot-scope="scope">
                <div class="d-flex align-items-center font-weight-bold">
                  {{ scope.row.zone_name }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('consolidatedSummary.farm')"
              min-width="150"
            >
              <template slot-scope="scope">
                <span class="font-weight-bold">{{ scope.row.farm_name }}</span>
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('consolidatedSummary.period')"
              prop="period_label"
              min-width="120"
              align="center"
            />

            <el-table-column prop="temp" min-width="85" align="center">
              <template slot="header">
                {{ $t('consolidatedSummary.temp') }}<br /><small>(°C)</small>
              </template>
              <template slot-scope="s">{{ formatVal(s.row.temp) }}</template>
            </el-table-column>
            <el-table-column prop="hr" min-width="75" align="center">
              <template slot="header">
                {{ $t('consolidatedSummary.hr') }}<br /><small>(%)</small>
              </template>
              <template slot-scope="s">{{ formatVal(s.row.hr) }}</template>
            </el-table-column>
            <el-table-column
              prop="precipitation"
              min-width="100"
              align="center"
            >
              <template slot="header">
                {{ $t('consolidatedSummary.precip') }}<br /><small>(mm)</small>
              </template>
              <template slot-scope="s">
                <span>{{ formatVal(s.row.precipitation) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="prob_lluvia" min-width="115" align="center">
              <template slot="header">
                {{ $t('consolidatedSummary.probLluvia') }}<br /><small
                  >(%)</small
                >
              </template>
              <template slot-scope="s">{{
                formatVal(s.row.rain_prob)
              }}</template>
            </el-table-column>
            <el-table-column prop="wind" min-width="105" align="center">
              <template slot="header">
                {{ $t('consolidatedSummary.viento') }}<br /><small
                  >(km/h)</small
                >
              </template>
              <template slot-scope="s">{{ formatVal(s.row.wind) }}</template>
            </el-table-column>
            <el-table-column prop="radiation" min-width="100" align="center">
              <template slot="header">
                {{ $t('consolidatedSummary.rad') }}<br /><small>(W/m²)</small>
              </template>
              <template slot-scope="s">{{
                formatVal(s.row.radiation)
              }}</template>
            </el-table-column>
            <el-table-column prop="dew_point" min-width="100" align="center">
              <template slot="header">
                {{ $t('consolidatedSummary.puntoRocio') }}<br /><small
                  >(°C)</small
                >
              </template>
              <template slot-scope="s">{{
                formatVal(s.row.dew_point)
              }}</template>
            </el-table-column>
            <el-table-column
              prop="vapor_deficit"
              min-width="120"
              align="center"
            >
              <template slot="header">
                {{ $t('consolidatedSummary.defVapor') }}<br /><small
                  >(kPa)</small
                >
              </template>
              <template slot-scope="s">{{
                formatVal(s.row.vapor_deficit)
              }}</template>
            </el-table-column>
            <el-table-column prop="eto" min-width="85" align="center">
              <template slot="header">
                {{ $t('consolidatedSummary.eto') }}<br /><small>(mm)</small>
              </template>
              <template slot-scope="s">
                <span>{{ formatVal(s.row.eto) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="irrigation_depth"
              min-width="160"
              align="center"
            >
              <template slot="header">
                {{ $t('consolidatedSummary.laminaSugerida') }}<br /><small
                  >(mm/ha)</small
                >
              </template>
              <template slot-scope="s">
                <span>{{ formatVal(s.row.irrigation_depth) }}</span>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>

        <div
          class="my-3 col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div>
            <p class="card-category">
              {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
              {{ to }} {{ $t('table2.of') }} {{ total }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>

        <hr class="my-3" />

        <!-- Tops del Periodo -->
        <el-table
          :data="topTableRows"
          border
          stripe
          style="width: 100%"
          class="mb-4"
        >
          <el-table-column
            :label="
              $t('common_words.table') +
              ': ' +
              $t('consolidatedSummary.topPeriodo')
            "
            align="center"
          >
            <el-table-column
              :label="$t('consolidatedSummary.indicador')"
              prop="indicador"
              min-width="180"
            />
            <el-table-column
              :label="$t('consolidatedSummary.valor')"
              min-width="120"
              align="center"
            >
              <template slot-scope="s">
                <span style="text-transform: none">{{ s.row.valor }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('consolidatedSummary.ubicacionFinca')"
              prop="finca"
              min-width="200"
            />
          </el-table-column>
        </el-table>

        <hr class="my-3" />

        <!-- Leyenda -->
        <el-table :data="legendTableRows" border stripe style="width: 100%">
          <el-table-column
            :label="
              $t('common_words.table') +
              ': ' +
              $t('consolidatedSummary.leyenda')
            "
            align="center"
          >
            <el-table-column
              :label="$t('consolidatedSummary.variable')"
              prop="variable"
              min-width="150"
            >
              <template slot-scope="s">{{ s.row.variable }}</template>
            </el-table-column>
            <el-table-column
              :label="$t('consolidatedSummary.significadoUnidad')"
              prop="meaning"
              min-width="300"
            >
              <template slot-scope="s">{{ s.row.meaning }}</template>
            </el-table-column>
          </el-table-column>
        </el-table>

        <hr class="my-3" />

        <export-tables
          :pdf="{
            filename: 'resumen_climatico_consolidado.pdf',
            route: 'climates/consolidatedsummary/pdf',
            paramMethod: 'POST',
            plusData: {
              summaryGeneral: summaryGeneral,
              tableData: tableData,
              topDaily: topDaily,
              legends: legendTableRows,
            },
          }"
          :xls="{
            filename: 'resumen_climatico_consolidado.xlsx',
            route: 'climates/consolidatedsummary/excel',
            paramMethod: 'POST',
            plusData: {
              summaryGeneral: summaryGeneral,
              tableData: tableData,
              topDaily: topDaily,
              legends: legendTableRows,
            },
          }"
        />
      </card>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import MixinDatePicker from 'src/util/mixinDatePicker';
import mixinFilter from 'src/util/mixinFilter';
import mixinLoading from 'src/mixins/mixin-loading';
import mixinMasters from 'src/util/mixinMasters';
import SweetAlert from 'src/class/Alerts';
import paginationData from './paginationData';
import Fuse from 'fuse.js';

export default {
  name: 'ConsolidatedSummary',

  components: {},

  mixins: [MixinDatePicker, mixinFilter, mixinLoading, mixinMasters],

  data() {
    return {
      loading: false,
      showReport: false,

      stations: [],
      zones: [],
      farms: [],

      payload: {
        stations: [],
        zones: [],
        farms: [],
        rangeDate: null,
        frecuency: 'daily',
        year_sel_init: null,
        year_sel_end: null,
        week_sel_init: 1,
        week_sel_end: 1,
      },

      listYears: {},

      activeCollapse: ['1'],
      renderDatePicker: true,
      typedatepicket: 'daterange',

      summaryGeneral: {
        temp_avg: 0,
        hr_avg: 0,
        rain_avg: 0,
        prob_avg: 0,
        wind_avg: 0,
        radiation_avg: 0,
        eto_avg: 0,
        rain_prob_avg: 0,
        total_location: 0,
      },
      topDaily: {
        rain_max: { value: null, farm_name: 'N/A' },
        rain_prob_max: { value: null, farm_name: 'N/A' },
        eto_max: { value: null, farm_name: 'N/A' },
        wind_max: { value: null, farm_name: 'N/A' },
        radiation_max: { value: null, farm_name: 'N/A' },
        irrigation_max: { value: null, farm_name: 'N/A' },
      },
      zoneSpans: [],

      pagination: paginationData.pagination,
    };
  },

  computed: {
    /**
     * Time interval options for the "Analyze by" selector.
     * Maps each frequency option to its corresponding date picker type.
     * @returns {Object} Dictionary of frequency options.
     */
    optionsInterval() {
      return {
        1: {
          id: 'daily',
          label: this.$t('common_words.day'),
          value: 'daterange',
        },
        2: { id: 'weekly', label: this.$t('common_words.week'), value: 'week' },
        3: {
          id: 'monthly',
          label: this.$t('common_words.month'),
          value: 'monthrange',
        },
        4: {
          id: 'annually',
          label: this.$t('common_words.year'),
          value: 'year',
        },
      };
    },

    /**
     * Cascades farm list based on selected stations or zones.
     * @returns {Array<Object>} Filtered farms applicable to the current selection.
     */
    filteredFarms() {
      let fms = this.farms;
      if (this.payload.stations && this.payload.stations.length > 0) {
        const validFarmIds = new Set();
        this.payload.stations.forEach((sId) => {
          const st = this.stations.find((s) => s.id === sId);
          if (st && st.farm_ids) {
            st.farm_ids.forEach((fid) => validFarmIds.add(fid));
          }
        });
        fms = fms.filter((f) => f.id === 0 || validFarmIds.has(f.id));
      } else if (this.payload.zones && this.payload.zones.length > 0) {
        fms = fms.filter(
          (f) => f.id === 0 || this.payload.zones.includes(f.zone_id)
        );
      }
      return fms;
    },

    /**
     * Cascades station list based on selected zones.
     * @returns {Array<Object>} Filtered stations applicable to the current selection.
     */
    filteredStations() {
      let st = this.stations;
      if (this.payload.zones && this.payload.zones.length > 0) {
        st = st.filter(
          (s) =>
            s.id === 0 ||
            (s.zone_ids &&
              s.zone_ids.some((zId) => this.payload.zones.includes(zId)))
        );
      }
      return st;
    },

    /**
     * Dynamically builds the rows for the Period Top Values table.
     * @returns {Array<Object>} Structured data rows for the top values table.
     */
    topTableRows() {
      return [
        {
          indicador: this.$t('consolidatedSummary.tops.mas_lluvia'),
          valor: this.formatVal(this.topDaily.rain_max.value) + ' mm',
          finca: this.topDaily.rain_max.farm_name,
        },
        {
          indicador: this.$t('consolidatedSummary.tops.mayor_prob_lluvia'),
          valor: this.formatVal(this.topDaily.rain_prob_max.value) + ' %',
          finca: this.topDaily.rain_prob_max.farm_name,
        },
        {
          indicador: this.$t('consolidatedSummary.tops.mayor_eto'),
          valor: this.formatVal(this.topDaily.eto_max.value) + ' mm',
          finca: this.topDaily.eto_max.farm_name,
        },
        {
          indicador: this.$t('consolidatedSummary.tops.mayor_viento'),
          valor: this.formatVal(this.topDaily.wind_max.value) + ' km/h',
          finca: this.topDaily.wind_max.farm_name,
        },
        {
          indicador: this.$t('consolidatedSummary.tops.mayor_radiacion'),
          valor: this.formatVal(this.topDaily.radiation_max.value) + ' W/m²',
          finca: this.topDaily.radiation_max.farm_name,
        },
        {
          indicador: this.$t('consolidatedSummary.tops.mayor_lamina'),
          valor: this.formatVal(this.topDaily.irrigation_max.value) + ' mm/ha',
          finca: this.topDaily.irrigation_max.farm_name,
        },
      ];
    },

    /**
     * Paginated and locally searched data using Fuse.js.
     * Overrides mixinMasters search to allow fuzzy matching without strict equality prefix.
     * @returns {Array<Object>} Current page slice of the queried dataset.
     */
    queriedData() {
      let result = this.tableData || [];
      if (this.searchQuery !== '') {
        result = this.fuseSearch
          ? this.fuseSearch.search(this.searchQuery)
          : [];
      }
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },

    /**
     * Upper bound index for pagination.
     * @returns {number} End index of the current page.
     */
    to() {
      let highBound = Number(this.from) + Number(this.pagination.perPage);
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },

    /**
     * Lower bound index for pagination.
     * @returns {number} Start index of the current page.
     */
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    /**
     * Total number of records in the table.
     * @returns {number} Row count of tableData.
     */
    total() {
      return (this.tableData || []).length;
    },

    /**
     * Dynamically builds the translated legend rows for the meteorological variables table.
     * @returns {Array<Object>} List of variables with their translated meanings.
     */
    legendTableRows() {
      return [
        {
          variable: this.$t('consolidatedSummary.legends.temp.variable'),
          meaning: this.$t('consolidatedSummary.legends.temp.meaning'),
        },
        {
          variable: this.$t('consolidatedSummary.legends.hr.variable'),
          meaning: this.$t('consolidatedSummary.legends.hr.meaning'),
        },
        {
          variable: this.$t('consolidatedSummary.legends.precip.variable'),
          meaning: this.$t('consolidatedSummary.legends.precip.meaning'),
        },
        {
          variable: this.$t('consolidatedSummary.legends.probLluvia.variable'),
          meaning: this.$t('consolidatedSummary.legends.probLluvia.meaning'),
        },
        {
          variable: this.$t('consolidatedSummary.legends.viento.variable'),
          meaning: this.$t('consolidatedSummary.legends.viento.meaning'),
        },
        {
          variable: this.$t('consolidatedSummary.legends.rad.variable'),
          meaning: this.$t('consolidatedSummary.legends.rad.meaning'),
        },
        {
          variable: this.$t('consolidatedSummary.legends.puntoRocio.variable'),
          meaning: this.$t('consolidatedSummary.legends.puntoRocio.meaning'),
        },
        {
          variable: this.$t('consolidatedSummary.legends.defVapor.variable'),
          meaning: this.$t('consolidatedSummary.legends.defVapor.meaning'),
        },
        {
          variable: this.$t('consolidatedSummary.legends.eto.variable'),
          meaning: this.$t('consolidatedSummary.legends.eto.meaning'),
        },
        {
          variable: this.$t('consolidatedSummary.legends.lamina.variable'),
          meaning: this.$t('consolidatedSummary.legends.lamina.meaning'),
        },
      ];
    },
  },

  watch: {
    queriedData(newVal) {
      this.computeZoneSpans(newVal || []);
    },
  },

  mounted() {
    this.getFilters();
  },

  methods: {
    /**
     * Handles frequency change (daily, weekly, monthly, annually).
     * Resets the date range and forces Element UI datepicker re-render.
     */
    changeByInterval() {
      this.payload.rangeDate = null;
      this.showReport = false;
      const option = Object.values(this.optionsInterval).find(
        (o) => o.id === this.payload.frecuency
      );
      this.typedatepicket = option ? option.value : 'daterange';
      this.renderDatePicker = false;
      this.$nextTick(() => {
        this.renderDatePicker = true;
      });
    },

    /**
     * Updates the local search query and resets pagination to page 1.
     * Extends mixinMasters.searchedQuery with pagination reset.
     * @param {string} val - Search text entered by the user.
     */
    searchedQuery(val) {
      this.searchQuery = val;
      this.pagination.currentPage = 1;
    },

    /**
     * Formats a numeric or string value for display; returns '-' if null, undefined or empty.
     * @param {number|string|null|undefined} val - Raw value.
     * @returns {string|number} Formatted display value.
     */
    formatVal(val) {
      return val !== null && val !== undefined && val !== '' ? val : '-';
    },

    /**
     * Fetches filter catalogs (stations, zones, farms) and year/week lists from the backend.
     * @returns {Promise<void>}
     */
    async getFilters() {
      this.showHideLoading(true);
      try {
        const [resFilters, resYears] = await Promise.all([
          Axios.getMasters('climates/consolidatedsummary/filters'),
          Axios.getMasters('climates/weatherstationreport/getselectinfo'),
        ]);
        const responseData =
          resFilters &&
          resFilters.data &&
          (resFilters.data.data || resFilters.data);
        if (responseData && responseData.stations) {
          this.stations = responseData.stations
            ? this.concatAll(responseData.stations)
            : [];
          this.zones = responseData.zones
            ? this.concatAll(responseData.zones)
            : [];
          this.farms = responseData.farms
            ? this.concatAll(responseData.farms)
            : [];

          const maxD =
            responseData.maxDate || new Date().toISOString().slice(0, 10);
          const initDate = new Date(maxD + 'T00:00:00');
          this.payload.rangeDate = [initDate, initDate];
        }
        if (resYears && resYears.data) {
          this.listYears = resYears.data.listYears || {};
          const years = Object.keys(this.listYears).reverse();
          if (years.length) {
            this.payload.year_sel_init = years[0];
            this.payload.year_sel_end = years[0];
          }
        }
      } catch (err) {
        console.error('[ConsolidatedSummary] getFilters:', err);
      } finally {
        this.showHideLoading();
      }
    },

    /**
     * Triggered when the zone selection changes.
     * Cascades cleanup of stations and farms that no longer match.
     */
    onZoneChange() {
      this.showReport = false;
      if (this.payload.zones && this.payload.zones.length > 0) {
        const validZones = new Set(this.payload.zones);

        this.payload.stations = this.payload.stations.filter((sId) => {
          const st = this.stations.find((s) => s.id === sId);
          return (
            st && st.zone_ids && st.zone_ids.some((z) => validZones.has(z))
          );
        });

        this.payload.farms = this.payload.farms.filter((fId) => {
          const farm = this.farms.find((f) => f.id === fId);
          return farm && validZones.has(farm.zone_id);
        });
      } else {
        this.payload.stations = [];
        this.payload.farms = [];
      }
    },

    /**
     * Triggered when the farm selection changes.
     */
    onFarmChange() {
      this.showReport = false;
    },

    /**
     * Triggered when the station selection changes.
     * Cascades cleanup of farms not associated with the selected stations.
     */
    onStationChange() {
      this.showReport = false;
      if (this.payload.stations && this.payload.stations.length > 0) {
        const validFarms = new Set();
        this.payload.stations.forEach((sId) => {
          const st = this.stations.find((s) => s.id === sId);
          if (st && st.farm_ids) {
            st.farm_ids.forEach((fid) => validFarms.add(fid));
          }
        });
        this.payload.farms = this.payload.farms.filter((fId) =>
          validFarms.has(fId)
        );
      } else {
        this.payload.farms = [];
      }
    },

    /**
     * Fetches consolidated climate report data from the backend.
     * @returns {Promise<void>}
     */
    async getReportData() {
      const needsRange =
        this.payload.frecuency !== 'weekly' &&
        this.payload.frecuency !== 'annually';
      if (
        needsRange &&
        (!this.payload.rangeDate || this.payload.rangeDate.length !== 2)
      )
        return;

      this.showHideLoading(true);
      this.showReport = false;

      try {
        const res = await Axios.postMasters({
          route: 'climates/consolidatedsummary/report',
          ...this.payload,
          frecuency: this.payload.frecuency || 'daily',
        });

        const responseData = res && res.data && (res.data.data || res.data);
        if (responseData) {
          this.summaryGeneral =
            responseData.summary_general || this.summaryGeneral;
          this.topDaily = responseData.top_daily || this.topDaily;
          this.tableData = responseData.rows || [];

          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: ['zone_name', 'farm_name', 'period_label'],
          });

          this.pagination.currentPage = 1;
          this.pagination.total = this.tableData.length;

          this.computeZoneSpans(this.queriedData);
          this.showReport = this.tableData.length > 0;

          if (this.tableData.length === 0) {
            SweetAlert.warning(this.$t('common_words.unavailable_data'));
          }
        }
      } catch (err) {
        console.error('[ConsolidatedSummary] getReportData:', err);
      } finally {
        this.showHideLoading();
      }
    },

    /**
     * Pre-computes how many consecutive rows share the same zone,
     * used by objectSpanMethod to merge zone cells in el-table.
     * The loop runs up to i === data.length using '__END__' as a sentinel to close the last group.
     * @param {Array<Object>} data - Current rows being rendered in the table.
     */
    computeZoneSpans(data) {
      this.zoneSpans = new Array(data.length).fill(0);
      let groupStart = 0;

      for (let i = 0; i <= data.length; i++) {
        const currentId = i < data.length ? data[i].zone_id : '__END__';
        const prevId = i > 0 ? data[i - 1].zone_id : null;

        if (i > 0 && currentId !== prevId) {
          this.zoneSpans[groupStart] = i - groupStart;
          groupStart = i;
        }
      }
    },

    /**
     * el-table span-method callback to merge consecutive cells sharing the same ZONE.
     * @param {Object} param0 - Current cell data provided by el-table.
     * @param {Object} param0.column - Column descriptor.
     * @param {number} param0.columnIndex - Zero-based column index.
     * @param {number} param0.rowIndex - Zero-based row index.
     * @returns {Object|undefined} Merge parameters (rowspan, colspan).
     */
    objectSpanMethod({ columnIndex, rowIndex }) {
      if (columnIndex === 0) {
        const span = this.zoneSpans[rowIndex];
        return span > 0
          ? { rowspan: span, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    },
  },
};
</script>

<style scoped>
.custom-shadow-card-header {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
}
</style>
